import { CommandParser } from '@redis/client/dist/lib/client/parser';
import { RedisArgument, NumberReply, Command } from '@redis/client/dist/lib/RESP/types';

export interface JsonForgetOptions {
  path?: RedisArgument;
}

export default {
  parseCommand(parser: CommandParser, key: RedisArgument, options?: JsonForgetOptions) {
    parser.push('JSON.FORGET');
    parser.pushKey(key);

    if (options?.path !== undefined) {
      parser.push(options.path);
    }
  },
  transformReply: undefined as unknown as () => NumberReply
} as const satisfies Command;
